/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";
import { getcompanyListViewObj } from "./helper";

const initialState = {
  list: [],
  all: [],
  error: null,
  loading: false,
  loaded: false,
  isLoading: false,
  isLoaded: false,
  total: 0,
  companySuccessResponse: null,
  favorites: [],
  currentCompany: {},
  togglingStatus: false,
  toggleStatusResponse: null,
  toggleStatusError: null,
  errorResponse: null,
  defaultCompany: null,
  currenyCompanyLoading: false,
  currentCompanyLoaded: true,
  switchCompany: null,
  isSwitchCompanyLoaded: false,
  isSwitchCompanyLoading: false,
  logs: [],
  companyFeatureResponse: null,
  currentCompanyFeature: [],
  companyDynamicResponse: null,
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_COMPANIES: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_COMPANIES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ...action.payload,
      };
    }
    case types.FETCH_COMPANIES_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_ALL_COMPANIES: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_ALL_COMPANIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        all: action.payload,
        favorites: getcompanyListViewObj(
          action.payload.filter((company) => company.favorite),
        ),
      };
    }
    case types.FETCH_A_COMPANY: {
      return {
        ...state,
        currenyCompanyLoading: true,
        currentCompanyLoaded: false,
      };
    }
    case types.FETCH_A_COMPANY_SUCCESS: {
      return {
        ...state,
        currenyCompanyLoading: false,
        currentCompanyLoaded: true,
        currentCompany: action.payload,
      };
    }
    case types.FETCH_A_COMPANY_FAILED: {
      return {
        ...state,
        currenyCompanyLoading: false,
        currentCompanyLoaded: true,
        error: action.payload,
      };
    }
    case types.REMOVE_COMPANY: {
      return {
        ...state,
        currentCompany: {},
        companySuccessResponse: null,
      };
    }
    case types.CREATE_COMPANY: {
      return {
        ...state,
        loading: true,
        loaded: false,
        companySuccessResponse: null,
        errorResponse: null,
      };
    }
    case types.CREATE_COMPANY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        companySuccessResponse: action.payload,
      };
    }
    case types.CREATE_COMPANY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }
    case types.UPDATE_COMPANY: {
      return {
        ...state,
        loading: true,
        loaded: false,
        companySuccessResponse: null,
        errorResponse: null,
      };
    }
    case types.UPDATE_COMPANY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        companySuccessResponse: action.payload,
      };
    }
    case types.UPDATE_COMPANY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }
    case types.ENABLE_COMPANY: {
      return {
        ...state,
        togglingStatus: true,
        toggleStatusResponse: null,
        toggleStatusError: null,
      };
    }
    case types.ENABLE_COMPANY_SUCCESS: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    case types.ENABLE_COMPANY_FAILED: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    case types.DISABLE_COMPANY: {
      return {
        ...state,
        togglingStatus: true,
        toggleStatusResponse: null,
        toggleStatusError: null,
      };
    }
    case types.DISABLE_COMPANY_SUCCESS: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    case types.DISABLE_COMPANY_FAILED: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    case types.DELETE_COMPANY: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.DELETE_COMPANY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        companySuccessResponse: action.payload,
      };
    }
    case types.DELETE_COMPANY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.SET_DEFAULT_COMPANY: {
      localStorage.setItem("default_company", JSON.stringify(action.payload));
      return {
        ...state,
        defaultCompany: action.payload,
      };
    }
    case types.SET_TRIAL_PERIOD: {
      return {
        ...state,
        loading: true,
        loaded: false,
        companySuccessResponse: null,
        errorResponse: null,
      };
    }
    case types.SET_TRIAL_PERIOD_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        companySuccessResponse: action.payload,
      };
    }
    case types.SET_TRIAL_PERIOD_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }

    case types.STAR_COMPANY: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.STAR_COMPANY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        favorites: [...state.favorites, action.payload],
      };
    }
    case types.STAR_COMPANY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.UN_STAR_COMPANY: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.UN_STAR_COMPANY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        favorites: state.favorites.filter((item) => {
          return item.companyuuid !== action.payload;
        }),
      };
    }
    case types.UN_STAR_COMPANY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_COMAPANY_LIST: {
      return {
        ...state,
        list: [],
        loading: false,
        loaded: false,
      };
    }
    case types.SWITCH_COMAPANY: {
      return {
        ...state,
        switchCompany: null,
        isSwitchCompanyLoading: true,
        isSwitchCompanyLoaded: false,
      };
    }
    case types.SWITCH_COMAPANY_SUCCESS: {
      return {
        ...state,
        isSwitchCompanyLoading: false,
        isSwitchCompanyLoaded: true,
        switchCompany: action.payload,
      };
    }
    case types.SWITCH_COMAPANY_FAILED: {
      return {
        ...state,
        isSwitchCompanyLoading: false,
        isSwitchCompanyLoaded: true,
        errorResponse: action.payload,
      };
    }
    case types.CLEAR_COMPANY_RESPONSE: {
      return {
        ...state,
        companySuccessResponse: null,
        errorResponse: null,
        logs: [],
      };
    }
    case types.FETCH_A_COMPANY_LOGS: {
      return {
        ...state,
        currenyCompanyLoading: true,
        currentCompanyLoaded: false,
      };
    }
    case types.FETCH_A_COMPANY_LOGS_SUCCESS: {
      return {
        ...state,
        currenyCompanyLoading: false,
        currentCompanyLoaded: true,
        logs: action.payload,
      };
    }
    case types.FETCH_A_COMPANY_LOGS_FAILED: {
      return {
        ...state,
        currenyCompanyLoading: false,
        currentCompanyLoaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_COMPANY_DETAILS: {
      return {
        ...state,
        currenyCompanyLoading: false,
        currentCompanyLoaded: false,
        currentCompany: {},
      };
    }
    case types.UPDATE_COMPANY_FEATURE: {
      return {
        ...state,
        companyFeatureResponse: null,
        errorResponse: null,
      };
    }
    case types.UPDATE_COMPANY_FEATURE_SUCCESS: {
      return {
        ...state,
        companyFeatureResponse: action.payload,
      };
    }
    case types.UPDATE_COMPANY_FEATURE_FAILED: {
      return {
        ...state,
        errorResponse: action.payload,
      };
    }
    case types.FETCH_COMPANY_FEATURE_LIST: {
      return {
        ...state,
        currentCompanyFeature: [],
      };
    }
    case types.FETCH_COMPANY_FEATURE_LIST_SUCCESS: {
      return {
        ...state,
        currentCompanyFeature: action.payload,
      };
    }
    case types.FETCH_COMPANY_FEATURE_LIST_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.UPDATE_COMPANY_DYNAMIC: {
      return {
        ...state,
        loading: true,
        loaded: false,
        companyDynamicResponse: null,
        errorResponse: null,
      };
    }
    case types.UPDATE_COMPANY_DYNAMIC_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        companyDynamicResponse: action.payload,
      };
    }
    case types.UPDATE_COMPANY_DYNAMIC_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
      };
    }
    case types.CLEAR_ERROR_RESPONSE: {
      return {
        ...state,
        errorResponse: null,
      };
    }
    default:
      return state;
  }
}
